export default {
  prepareSequenceImages: Array(31)
    .fill("")
    .map((v, i) =>
        require(`../../../Box_sequences/00_TV_clean_box/TV_clean_box${i < 10 ? `0${i}` : i}.jpg`)
  ),
  designSliderImage: require("../../../product drawing/cat tunnel.png"),
  designImageList: [
    {
      number: 1,
      side: "FRONT",
      image: require("../../../parts/cattunnel/02.png")
    },
    {
      number: 2,
      side: "BACK",
      image: require("../../../parts/cattunnel/03.png")
    },
    {
      number: 3,
      side: "MIDDLE",
      image: require("../../../parts/cattunnel/04.png")
    },
  ],
  cutOutPartsImage: require("../../../parts/cattunnel/05.png"),
  cutOutPartsFoldImage2: require("../../../parts/cattunnel/fold.png"),
  assembleSequenceImages: Array(46)
    .fill("")
    .map((v, i) =>
      require(`../../../sequences/07_cattunnel_sequence/cattunnel${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),
  completeImage: require("../../../complete/cattunnel.png"),
  completeImagePc: require("../../../complete/cattunnel.png")
};
